import React from 'react'
import UserPage from '../../common/UserPage/UserPage';
import Footer from '../../common/Footer/Footer';
import UserSettings from '../../components/UserSettings/UserSettings'
import { useSelector } from 'react-redux'

function UserSettingsPage() {
    const { currentUser } = useSelector((state) => state.users);
  return (
    <div>
        <UserPage customImage={currentUser?.picture} />
        <UserSettings />
        <Footer />
    </div>
  )
}

export default UserSettingsPage